import { render } from "./AdminOrderDetails.vue?vue&type=template&id=51a9a40b&scoped=true"
import script from "./AdminOrderDetails.vue?vue&type=script&lang=js"
export * from "./AdminOrderDetails.vue?vue&type=script&lang=js"

import "./AdminOrderDetails.vue?vue&type=style&index=0&id=51a9a40b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a9a40b"]])

export default __exports__